var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJianzhuwu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631277",
    d: "M2.20312 14.5228V4.53717L8.99882 1.72515V14.5228H2.20312Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631278",
    d: "M13.7031 14.5229V7.4287L8.99076 5.47876V14.5229H13.7031Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 4.01562,
    y1: 6.42911,
    x2: 7.14062,
    y2: 6.42911,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 4.01562,
    y1: 8.92911,
    x2: 7.14062,
    y2: 8.92911,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    x1: 4.01562,
    y1: 11.4916,
    x2: 7.14062,
    y2: 11.4916,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 14",
    d: "M0.265625 14.5229H15.7344",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJianzhuwu);
export default __webpack_public_path__ + "static/media/jianzhuwu.9f781149b1731d1c2d56cd82551fb242.svg";
export { ForwardRef as ReactComponent };